import { FormControlLabel, Switch } from "@mui/material";
import { forwardRef } from "react";
import { MetadataInputProps } from "../metadata-input-index";

const MetadataInputBool = forwardRef<any, MetadataInputProps>((props, ref) => {
  const { onChange, data, value } = props;

  return (
    <FormControlLabel
      checked={value ? value.value : false}
      value={value ? value.value : false}
      onChange={(e, value) => onChange(value, data.id)}
      control={<Switch />}
      label=""
    />
  );
});

export default MetadataInputBool;
